export const API_HOST = 'https://staging.chefami.com';
export const environment = {
  production: false,
  imagePath: '/assets/img/',
  recipesLink: `${API_HOST}/recipes/`,
  recipeImagePath: `${API_HOST}/img/recipe/`,
  locationsImagePath: `${API_HOST}/img/locations/`,
  googleApiKey: 'AIzaSyDrF6KP4NQj3XttjIh7YetF_oEvP87pqWw',
  getSiteData: `${API_HOST}/api/fetch-site-data`,
  validateUser: `${API_HOST}/api/validate-user`,
  getNewSubscriptionDetails: `${API_HOST}/api/get-new-subscription-details`,
  createSubscription: `${API_HOST}/api/create-subscription`,
  applyCoupon: `${API_HOST}/api/apply-coupon`,
  login: `${API_HOST}/api/login`,
  checkZipDeliveryDay: `${API_HOST}/api/check-zip-delivery-day`,
  claimFreeMeal: `${API_HOST}/api/claim-free-meal`,
  referralCoupon: `${API_HOST}/api/claim-referral-code`,
  cookieDomain: '.chefami.com',
  maintainence: `${API_HOST}/maintenance.php`,
  claimCoupon: `${API_HOST}/api/claim-coupon`,
  weeklyMenuRecipes: `${API_HOST}/api/get-weekly-recipes`,
  choosePlanBeforeCheckout: `${API_HOST}/api/choose-plan`,
  checkZipCode: `${API_HOST}/api/check-zip-code`,
  validateSubscriptionData: `${API_HOST}/api/validate-subscription-data`,
};
